export default __webpack_public_path__ + "static/media/team-foto2-color.5eb1ade1.png";